<template>
  <Form 
    :d_form='form'
    :d_lkp_negeri='lkp_negeri'
    v-if="id > 0 && load == 2"
  />
  <Form 
    :d_form='form'
    :d_lkp_negeri='lkp_negeri'
    v-else-if="id == 0 && load == 1"
  /> 
  <Form 
    :d_form='form'
    :d_lkp_negeri='lkp_negeri'
    v-else-if="id == 0 && load == 2"
  /> 
</template>



<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.permohonan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        // { label: 'Daftar Tangki LN2', route: '/tangki' },
        { label: 'Pemeriksaan Fertiliti', route: 'art/permohonan/ferteliti/{id}' },
      ],
      title : 'Permohonan Fertiliti',
      form : {
        id             : 0,
        premis_id      : '',
        masa           : '',
        jantina        : '',
        pemeriksa_id   : '',
        lkp_negeri_id  : '',
        lkp_status_id  : '',
        lkp_ternakan_id: '',
        lkp_art_id: '',
        penilai_id : '',   
        tarikh_temujanji : '',
        kode : '',
        jantina : '',
        p : 0,
        ternakan_list : [],
      },
      premis_id : [],
      ternakan_list:[],
      premis : [],
      pemeriksa :[],
      juruteknik_list : [],
      lkp_ternakan : [],
      lkp_status : [],
      penilai : [],
      tarikh_temujanji : [],
      lkp_tujuan : [],
      jantina : [],
      load : 0
      
      
    }
  },
  methods: {
    

      
 
     getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'art/show/'+this.id, {}).then(res => {
          this.form = res
          this.load = this.load + 1
        })
      }

    },


    getJantina(){
      this.$zcomm.get(this.api_service + 'lookup/jantina', {}).then(res => {
        this.jantina = res
      })
    },


    getSalin(id){
        this.$zcomm.get(this.api_service + 'art/show/'+id, {}).then(res => {
          this.form = res
          this.form.id = 0
          this.load = this.load + 1
        })

       
      },

    getNegeri(){
         this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
            this.lkp_negeri = res
            this.load = this.load + 1
         })
    },

   
  
  },

  watch: {

  },
  mounted() {
    this.getData()
    this.getNegeri()
    this.getJantina()
    this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.params.salin && this.params.salin > 0){
      
      this.getSalin(this.params.salin)
    }
    
  }
    
}
</script>
